module.exports = function () {
    const header = document.querySelector(".header");
    if ( !header ) return;
    
    let isOpenMenu = false;
    const hamButton = header.querySelector(".header__ham");
    const navigation = header.querySelector(".header__navigation");
    const isDesktop = window.matchMedia("(min-width: 1024px)");
    let lastScrollY = window.scrollY;
    
    function openMenu() {
        isOpenMenu = true;
        document.body.classList.add("overflow-hidden");
        header.classList.add("open");
        
        setTimeout(() => {
            document.addEventListener("click", closeOutSide);
        })
    }
    
    function closeMenu() {
        isOpenMenu = false;
        document.body.classList.remove("overflow-hidden");
        header.classList.remove("open");

        document.removeEventListener("click", closeOutSide);
    }
    
    function closeOutSide(e) {
        if ( !navigation.contains(e.target) ) closeMenu();
    }
    
    // toggle menu
    hamButton.addEventListener("click", () => isOpenMenu ? closeMenu() : openMenu());
    
    window.addEventListener("resize", () => {
        if ( isOpenMenu && isDesktop.matches ) closeMenu();
    })
    
    document.addEventListener("scroll", handleScroll);
    handleScroll();
    
    function handleScroll() {
        if ( window.scrollY > lastScrollY + 50 ) {
            header.classList.add("hide");
            lastScrollY = window.scrollY;
        }
        else if ( window.scrollY < lastScrollY ) {
            header.classList.remove("hide");
            lastScrollY = window.scrollY;
        }

        if ( window.scrollY > 25 ) {
            header.classList.add("scroll");
        }
        else {
            header.classList.remove("hide");
            header.classList.remove("scroll");
        }
    }
}